import { useState, useEffect, useRef } from 'react';
import { api } from '../services/api';

export const ServerStatus = () => {
  const [heartbeat, setHeartbeat] = useState(null);
  const consecutiveInactive = useRef(0);
  const INACTIVE_THRESHOLD = 3; // require 3 consecutive inactive (~15s) before flipping

  useEffect(() => {
    let isMounted = true;

    const checkHeartbeat = async () => {
      try {
        const data = await api.getHeartbeat();
        if (isMounted) {
          if (data.status === 'active') {
            consecutiveInactive.current = 0;
            setHeartbeat({
              lastMessageTimestamp: data.lastMessageTimestamp,
              status: 'active'
            });
          } else {
            consecutiveInactive.current += 1;
            if (consecutiveInactive.current >= INACTIVE_THRESHOLD) {
              setHeartbeat({
                lastMessageTimestamp: data.lastMessageTimestamp,
                status: 'inactive'
              });
            }
          }
        }
      } catch (error) {
        if (isMounted) {
          consecutiveInactive.current += 1;
          if (consecutiveInactive.current >= INACTIVE_THRESHOLD) {
            setHeartbeat({
              status: 'inactive',
              lastMessageTimestamp: null
            });
          }
        }
      }
    };

    checkHeartbeat();
    const interval = setInterval(checkHeartbeat, 5000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, []);


  return (
    <div className="bg-white rounded-lg shadow-sm p-3 flex items-center gap-4">
      <div className="flex items-center gap-2">
        <div className={`w-2 h-2 rounded-full ${
          heartbeat?.status === 'active' ? 'bg-green-500' : 'bg-red-500'
        }`} />
        <span className="text-sm font-medium">
          {heartbeat?.status === 'active' ? 'Active' : 'Inactive'}
        </span>
      </div>
    </div>
  );
};